import React, { useState } from 'react';

import { DataTable } from "primereact/datatable";
import useUserStore from "../../../../../utils/storeApp";
import { Column } from "primereact/column";
import { gridObj } from "../../../../../services/fakeDB/ReportObj";

const ListOrgEmailDeleteActivity = () => {
    const { isUserLogedIn, userRole, userToken } = useUserStore((state) => ({
        isUserLogedIn: state.isUserLogedIn,
        userRole: state.userRole,
        userToken: state.userToken,
    }));

    const [userObj, setUserObj] = useState([]);

    const [showGridFlag, SetShowGridFlag] = useState(
        userRole === "SESADMIN" ? false : true
    );
    const [showEmptyGridFlag, SetShowEmptyGridFlag] = useState(
        userRole === "SESADMIN" ? true : false
    );

    return (
        <div className="ListOrgEmailDeleteActivity">
            {/*{showEmptyGridFlag ?*/}
            {/*    (<section className="empty-grid">*/}
            {/*        There are currently no search results.*/}
            {/*    </section>*/}
            {/*    ) : null}*/}

            {/* {showGridFlag ? (*/}
            {userRole !== "SESADMIN" ? null : (
                <section className="grid-header-bar" aria-labelledby="Grid Header Bar">
                    <div className="spacer-inline spacer-margin1">
                        <span className="ft-wt">Domain:</span> <span>test@direct-address.com</span>
                    </div>
                    <div className="spacer-inline">
                        <span className="ft-wt">Customer:</span> <span>Humana</span>
                    </div>
                </section>
            )}

            <section className="grid-layout">
                <div>
                    <DataTable
                        value={gridObj}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 25, 50]}
                        tableStyle={{ minWidth: "50rem" }}
                        dataKey="Id"
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        selectionMode="single"
                        columnResizeMode="expand"
                        resizableColumns
                    >
                        <Column field="DirectEmail" header="Direct Email" className="print-col" sortable></Column>
                        <Column field="Org" header="Organization" className="print-col" sortable></Column>
                        <Column field="Domain" header="Domain" className="print-col" sortable></Column>
                        <Column field="DeletedReason" header="Reason" className="print-col" sortable></Column>
                        <Column field="DateTimeDeleted" header="Date/Time Deleted" className="w-md8" sortable></Column>
                        <Column field="DeletedBy" header="Deleted By" className="print-col" sortable></Column>
                    </DataTable>
                </div>
            </section>
            {/*  ) : null}*/}
        </div>
    )
};

ListOrgEmailDeleteActivity.propTypes = {};

ListOrgEmailDeleteActivity.defaultProps = {};

export default ListOrgEmailDeleteActivity;
